import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { H3, Button, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Paper } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { PUBLIC_URL, ANALYTICS_URL, SERVER_URL} from '../../../constants'
import Tree from './Tree'
import Meta from './Meta'
import Tokens from './Tokens'
import Context from './Context'

//import ReactAudioPlayer from 'react-audio-player';

// TODO : gérer l'expansion de l'accordeon avec les fonction global de toggleDisplay
// pour le moment, quand on joue sur la prop. expand='this.props.display...' tous les accordéons s'ouvrent
// et se ferment en même temps.

class MetaData extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = { 

    };
  }



  render() {

    const { permalink, metadata } = this.props.concordDetail;
    const { t, sent_id, displayPlay, displayTree} = this.props;
    
    var m=permalink.match(/collection=(.*)&sentId=(.*)_(\d+)$/);
    var numSent;
    var fileId;
    var collection;
    var intervalSentNum;
  
    if (m) {
      collection=m[1];
      fileId=m[2];
      numSent=m[3];
      const firstSent=parseInt(numSent)-10>0? parseInt(numSent)-10 : 0;
      const lastSent=parseInt(numSent)+10;
      intervalSentNum= firstSent.toString()+"#"+lastSent.toString();
      // console.log(collection,fileId,numSent,intervalSentNum);
    }
 

    return (
      <>
      <Paper className="padding-1-rem">
        <div>ID : {sent_id}</div>
        { (permalink) &&
          <div>{t('permalink')} : <a href={SERVER_URL+PUBLIC_URL+ANALYTICS_URL+permalink}>{SERVER_URL+PUBLIC_URL+ANALYTICS_URL+permalink}</a></div>
        }
        { (metadata.wavLink) &&
          <center>
            <br/>
            <Button onClick={displayPlay}> <Icon icon={IconNames.PLAY} iconSize={50} /></Button>
          </center>
        }
        <br/>
        <Accordion defaultExpanded={true} >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <H3>{t('docMeta')}</H3>
          </AccordionSummary>
          <AccordionDetails>

            <Meta metadata={ this.props.concordDetail.metadata } />

          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <H3>{t('largeContext')}</H3>
          </AccordionSummary>
          <AccordionDetails>

            <Context 
                  concordDetail={ this.props.concordDetail} 
                  fileId= {fileId}
                  collection= {collection}
                  language= {this.props.lang}
                  intervalSentNum= {intervalSentNum}
                  pasteQuery= {this.props.pasteQuery}
            />
          
          </AccordionDetails>
        </Accordion>
        
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <H3>{t('tokens')}</H3>
          </AccordionSummary>
          <AccordionDetails>
          
            <Tokens tokens={ this.props.concordDetail.tokens }/>
            
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
          <H3>{t("syntaxicTree")}</H3>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{flex:'none',width:600}}>
              <Button onClick={displayTree} > {t('enlarge')}</Button>
              <Tree svg={this.props.concordDetail.svg}/>
            </div>
          </AccordionDetails>
        </Accordion>
      </Paper>


      </>
    );
  }
}


MetaData.propTypes = {
  sent_id:PropTypes.string,
  concordDetail: PropTypes.shape({
    permalink: PropTypes.string,
    metadata: PropTypes.object,
    left_context: PropTypes.string,
    sentence: PropTypes.string,
    right_context: PropTypes.string,
    svg: PropTypes.string,
    conll: PropTypes.string,
    alignedSents: PropTypes.string,
    tokens: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      cat: PropTypes.string,
      fea: PropTypes.string,
      lem: PropTypes.string,
      form: PropTypes.string,
    })),
    relations: PropTypes.arrayOf(PropTypes.shape({
      gouv: PropTypes.string,
      dep: PropTypes.string,
      rel: PropTypes.string,
    })),
  }),
  displayTree: PropTypes.func,
  displayPlay: PropTypes.func,
  pasteQuery: PropTypes.func,
  lang: PropTypes.string,
  
};

export default withTranslation()(MetaData);
